interface ExistingMedia {
  type: string | null;
  count: number;
}

export interface MediaChoice {
  existingMedia?: unknown; // the tool input, so anything until checked here
  photoIndex?: unknown;
}

const MEDIA_NAMES: Record<string, string> = {
  html: "a Willow Create visual",
  video: "a video",
  pdf: "a document",
  article: "a link preview"
};

const checkPhotoIndex = ({ type, count }: ExistingMedia, { existingMedia, photoIndex }: MediaChoice): string | null => {
  if (type !== "photo") return "photoIndex only applies when the post has photos; leave it out.";
  if (existingMedia !== "replace") return "photoIndex goes with existingMedia replace.";
  const isPhoto = Number.isInteger(photoIndex) && (photoIndex as number) >= 0 && (photoIndex as number) < count;
  return isPhoto ? null : `No photo at index ${photoIndex}. Valid indexes: 0 to ${count - 1}.`;
};

// The reason to ask the user before an image goes on the post, or null when it can go ahead.
export const checkExistingMedia = (media: ExistingMedia, choice: MediaChoice): string | null => {
  const { type, count } = media;
  if (choice.photoIndex !== undefined) return checkPhotoIndex(media, choice);
  if (!type || count === 0) return null;
  if (type === "photo") {
    if (choice.existingMedia === "add" || choice.existingMedia === "replace") return null;
    if (count === 1) {
      return "The post already has a photo. Unless the user already said, ask whether the image goes next to it or replaces it, then call again with existingMedia add or replace.";
    }
    return `The post already has ${count} photos. Unless the user already said, ask whether the image goes next to them, replaces one of them or replaces all ${count}, then call again with existingMedia add, existingMedia replace with that photo's photoIndex, or existingMedia replace.`;
  }
  if (choice.existingMedia === "replace") return null;
  return `The post already carries ${MEDIA_NAMES[type] ?? "an attachment"}, which an image would replace, because the two cannot sit side by side. Unless the user already asked for that, ask first, then call again with existingMedia replace.`;
};
